import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/fashionable-inc-shopify-plus-partnership-case-study.en.md?raw";

const PATH = "/resources/fashionable-inc-partnership-case-study";
const ALT = "/es/recursos/caso-fashionable-inc-colaboracion";
const TITLE = "Fashionable INC: A 6+ Year Shopify Plus Partnership Across Three Stores";
const META_TITLE = "Fashionable INC Shopify Plus Partnership Case Study · Shugert";
const DESCRIPTION = "How Shugert supports Fashionable INC across three Shopify Plus stores over 6+ years of theme migrations, SEO, custom development and performance work.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Shugert Marketing partner profile", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Fashionable Canes", publisher: "Fashionable INC", href: "https://fashionablecanes.com/" },
  { label: "Fashionable Hats", publisher: "Fashionable INC", href: "https://fashionablehats.com/" },
  { label: "TENS Units", publisher: "Fashionable INC", href: "https://tensunits.com/" },
];

const RELATED = [
  { label: "Fashionable Canes SEO case study", href: "/resources/fashionable-canes-seo-case-study" },
  { label: "Shopify Plus agency", href: "/shopify-plus-agency" },
  { label: "Ongoing Shopify engineering", href: "/retainer" },
  { label: "All Shopify case studies", href: "/work" },
];

export const Route = createFileRoute("/resources/fashionable-inc-partnership-case-study")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Shopify Plus partnership case study", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Shopify Plus partnership case study" }),
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Work", path: "/work" }, { name: "Fashionable INC case study", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="en" path={PATH} title={TITLE}
        excerpt="What changes when Shopify work becomes a six-year operating relationship across three Plus stores instead of a sequence of disconnected projects."
        body={body} updated="August 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="How technical continuity, theme lifecycle management, SEO, custom development, performance, and portfolio governance work across three Shopify Plus stores over time."
        audience="Multi-store Shopify Plus organizations whose roadmap repeatedly crosses engineering, SEO, performance, migrations, and platform decisions."
        sources={SOURCES} related={RELATED}
        category="Shopify Plus partnership case study" backLabel="← Work" backHref="/work"
        cta={{ eyebrow: "Multi-store Shopify Plus", title: "Keep context when the roadmap spans more than one project.", body: "We recommend ongoing capacity only when the remaining roadmap repeatedly crosses systems, SEO, performance, and engineering decisions where retained context has measurable value.", label: "Discuss the roadmap", href: "/get-a-quote?intent=retainer&source=fashionable-inc-case-study" }}
      />
    </SiteShell>
  ),
});
